import { z } from "zod";

export const getAssignPartnerFormSchema = () => {
	return z.object({
		partnerId: z.number().nullish(),
	});
};

export type AssignPartnerFormModel = z.infer<
	ReturnType<typeof getAssignPartnerFormSchema>
>;
